import React from "react";

import HistoryTimeline from "components/Shared/HistoryTimeline";

import { useShipmentDetailContext } from "contexts/ShipmentDetailContext";

const ShipmentHistoryTab = () => {
  const { ShipmentDetail } = useShipmentDetailContext();

  const sortedShipmentHistory =
    [...ShipmentDetail?.history]?.sort((a, b) =>
      a?.createdAt > b?.createdAt ? -1 : 1
    ) ?? [];

  return (
    <>
      <HistoryTimeline timelineItems={sortedShipmentHistory} />
    </>
  );
};

export default ShipmentHistoryTab;
